import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'featuredImage', label:"Image", sortable: true },
    
    { key: 'title', label:"Title", sortable: true },
    
    { key: 'assetType', label:"Type", sortable: true },
   
   
    { key: 'createdAt',label:"Create" },
    { key: 'actions',label:"Actions" },
    
  
    
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)
  const allCategories = ref(null)
  const selectedCategory = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    //console.log("fetch trigereed");

    refUserListTable.value.refresh()
  }

  watch([currentPage,selectedCategory, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  })
  
 
  const fetchInstructers = (ctx, callback) => {

    var cat=selectedCategory.value==null||selectedCategory.value==undefined?0:selectedCategory.value.id;

    store
      .dispatch('apps-librarylist/fetchAllPages', {
          currentPage: currentPage.value,
        perPage:perPage.value,
        searchQuery:searchQuery.value,
        c:cat,
        q: searchQuery.value,
        l: perPage.value,
        p:currentPage.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
      })
      .then(response => {
        const { data, totalposts } = response.data
            //console.log("some resposne");
            //console.log(totalposts);

          totalUsers.value = totalposts  
        callback(data)
      
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }


  const fetchCategories = (ctx, callback) => {
    store
      .dispatch('apps-librarylist/fetchAllCategories', {
          currentPage: currentPage.value,
        perPage:perPage.value,
        searchQuery:searchQuery.value,
        q: searchQuery.value,
        l: perPage.value,
        p:currentPage.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
      })
      .then(response => {
        const { data, totalposts } = response.data
            //console.log("some resposne");
            //console.log(totalposts);

            allCategories.value = data  
        
      
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }
  fetchCategories();

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status ===0) return 'warning'
    if (status === 1) return 'success'
    if (status === 100) return 'success'
    if (status === 2) return 'secondary'
    return 'secondary'
  }
  const resolveUserStatusVariantText = status => {
    if (status ===0) return 'draft'
    if (status === 100) return 'published'
    if (status === 1) return 'active'
    if (status === 2) return 'disabled'
    return 'deleted'
  }

  return {
    fetchInstructers,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    resolveUserStatusVariantText,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
    allCategories,
    selectedCategory
  }
}
